module.exports = __webpack_public_path__ + "media/packs/images/flags/MZ-62c1c50716920f6ecd12ba3ec0964b75.png";